import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { LOGOSVG } from '../../assets';
import OpenAppBtn from '../../components/common/OpenAppBtn';
import SocialLoginButtons from '../../components/socialLogin/SocialLoginButtons';
import { ThirdPartyContext } from '../../contexts/ThirdPartyContext';
import GuestInquiryModal from '../../components/modals/GuestInquiryModal';
import Header from '../../components/Header';
import SafariLoginInfoImage from '../../assets/login-info-image.svg';

export default function LoginMainPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { state: collaborationState, setState: collaborationSetState } = useContext(ThirdPartyContext);
  const [guestInquiryisOpen, setGuestInquiryIsOpen] = useState(false);
  const [showSafariPopup, setShowSafariPopup] = useState(false);

  useEffect(() => {
    // 살루스케어(비타포트)에서 유입된 유저
    if (!searchParams.has('provNo')) {
      return;
    }

    collaborationSetState({
      ...collaborationState,
      thirdPartyId: searchParams.get('provNo') || '',
      thirdPartyCode: searchParams.get('provNo') === '11' ? 'VITAPORT' : undefined,
      thirdPartyUserId: searchParams.get('mberNo') || '',
      orderNumber: searchParams.get('orderNo') || '',
    });
    }, []);

      // 브라우저가 Safari인지 감지하여 팝업 노출 (iOS + macOS)
  useEffect(() => {
    if (typeof navigator === 'undefined') return;

    const ua = navigator.userAgent || '';
    const vendor = navigator.vendor || '';
    const uaLower = ua.toLowerCase();

    // iOS detection
    const isIOS = /(iphone|ipad|ipod)/i.test(uaLower) || /iP(hone|ad|od)/.test(navigator.platform || '');

    // Common in-app browsers that include "Safari" token in UA
    const isInApp = /(kakaotalk|naver|fbios|fbav|instagram|line|daumapps|whale)/i.test(ua);

    // True Mobile Safari (excludes Chrome/Firefox/Edge on iOS and OPiOS, etc.)
    const isMobileSafari = /safari/i.test(ua) && /apple/i.test(vendor) && !/(CriOS|FxiOS|EdgiOS|OPiOS|OPR|EdgA)/.test(ua);

    // macOS Safari (desktop)
    const isMacOSSafari = /Macintosh/.test(ua) && /Version\/\d+.*Safari/.test(ua) && /Apple/.test(vendor);

    const shouldShow = ((isIOS && isMobileSafari) || isMacOSSafari) && !isInApp;

    if (shouldShow) setShowSafariPopup(true);
  }, []);

  return (
    <div className="flex flex-col items-center justify-start w-full">
        <style>
        {`
          header {
            display: flex !important;
          }
          header .ant-select {
            display: none !important;
          }
          @media (max-width: 767px) {
            header {
              padding: 15px 20px !important;
              }
              header a{
              font-size: 14px !important;
              }
          }
        `}
      </style>
      <Header/>
      {showSafariPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1C1C1E] rounded-[16px] w-[320px] pt-[36px] pl-[24px] pr-[24px] pb-[20px] text-center text-white relative">
            <img src={SafariLoginInfoImage} alt="Safari Login Info" className="w-[150px] mx-auto mb-4" />
            <p className="text-[15px] leading-[22px] font-medium mb-2">현재 아이폰 기본 브라우저(사파리)에서는</p>
            <p className="text-[24px] font-bold mb-3">⚠️ 카카오톡 로그인이<br/> 오류가 날 수 있어요!</p>
            <p className="text-[19px] leading-[22px] mb-4">
              <div className=' inline-block bg-[#1f3eef] p-[3px]'><span className="font-bold">이럴 땐 사운드필 앱</span></div>으로<br />바로 접속해 주세요☺️
            </p>
            <button
              className="w-full bg-[#4F68FC] text-white text-[16px] p-[16px] rounded-[8px] font-semibold"
              onClick={() => setShowSafariPopup(false)}
            >
              확인했어요
            </button>
          </div>
        </div>
      )}
      <div className='flex justify-end items-center w-full mt-[65px] pr-5'>
        <OpenAppBtn />
      </div>

      {/* <div className="flex items-center justify-between w-full px-5 mt-5 md:flex-row-reverse mb-[128px]">
        <LOGOSVG className="md:hidden w-[93px] " />
        <div className="flex gap-[6.75px]">
          <OpenAppBtn />
        </div>
      </div> */}
      <main className='flex flex-col items-center w-full md:w-[539px] px-10 py-20
      absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-transparent md:bg-white'>
        <section className="flex flex-col items-center text-lg font-bold text-N0 leading-[26px] mb-3 md:mb-[21px] md:text-xl">
          {/* <LOGOSVG className="max-md:hidden mb-[34px] md:w-[163px]" /> */}
          {/* <h1 className="text-center md:w-[30rem]">{t('web.introText')}</h1> */}
          <span
            className="text-[20px] md:text-gray-500 text-gray-200 text-align-center font-medium font-weight-700 md:leading-[110%] leading-[140%]"
          style={{ fontFamily: "'NanumSquare Neo', Pretendard", letterSpacing: '-0.6px' }}
          >
            {t('login.subtitle')}
          </span>
          {/* 데스트탑에서만 보임 */}
          <h1
            className='hidden md:block text-[32px] text-black text-align-center font-medium font-weight-700 leading-[110%] mt-4'
          style={{ fontFamily: "'NanumSquare Neo', Pretendard", letterSpacing: '-0.6px' }}
          >
            {t('login.title')}
          </h1>

          {/* 모바일에서만 보임 */}
          <div className='block md:hidden w-full items-center text-center'>
            <h1 
              className='text-white text-align-center text-[24px] font-medium font-weight-900 leading-[110%] py-3'
              style={{ fontFamily: "'NanumSquare Neo', Pretendard", letterSpacing: '-0.72px' }}
            >
            {t('login.title')}
            </h1>
          </div>
        </section>
        <section className="flex flex-col items-center justify-between mt-12">
          {/* <span className="text-[15px] text-N1 font-medium">{t('web.socialLogin')}</span> */}
          <SocialLoginButtons />
          <div className='block md:hidden w-full text-center pt-4'>
            <span
              className="text-gray-300 text-[16px] font-weight-500 tracking-[-0.72px] px-5 hover:text-[#4F68FC]"
              style={{ letterSpacing: '-0.4px' }}
              onClick={() => { setGuestInquiryIsOpen(true) }}
            >
              {t('login.problem')}
            </span>
            <GuestInquiryModal isOpen={guestInquiryisOpen} setIsOpen={setGuestInquiryIsOpen} />
          </div>
        </section>
      </main>
    </div>
  );
}
